import { validStateValues } from '@black-bear-energy/black-bear-energy-common'
import { SiteAction } from 'common/types'
import { IDeveloperField } from 'dromo-uploader-react'

// actions available for a site from the upload list that has a potential
// match to an existing record
export const uploadMatchedRecordSiteActionOptions = [
  { label: SiteAction.Ignore, value: SiteAction.Ignore },
  { label: SiteAction.New, value: SiteAction.New },
  { label: SiteAction.Review, value: SiteAction.Review },
  { label: SiteAction.Update, value: SiteAction.Update },
]

// actions available for a site from the upload list that does not
// match any existing record
export const uploadUnmatchedRecordSiteActionOptions = [
  { label: SiteAction.Ignore, value: SiteAction.Ignore },
  { label: SiteAction.New, value: SiteAction.New },
  { label: SiteAction.Review, value: SiteAction.Review },
]

// actions available for a record from the existing db that did not
// match any sites in the upload list
export const existingRecordSiteActionOptions = [
  { label: SiteAction.Ignore, value: SiteAction.Ignore },
  { label: SiteAction.Sold, value: SiteAction.Sold },
  { label: SiteAction.Review, value: SiteAction.Review },
]

export const zipCodeRegex = /^((\d{5}(-\d{4})?)|([A-Z]\d[A-Z] \d[A-Z]\d))$/

export const siteActionSchema: IDeveloperField = {
  label: 'Site Action',
  key: 'siteAction',
  type: 'select',
  selectOptions: uploadUnmatchedRecordSiteActionOptions,
  validators: [
    {
      validate: 'regex_exclude',
      regex: SiteAction.Review,
      errorMessage: 'Review this record and choose the correct action',
    },
  ],
}

export const nameSchema: IDeveloperField = {
  label: 'Site Name',
  key: 'name',
  alternateMatches: ['property name', 'asset name', 'property: property name'],
}

export const addressSchema: IDeveloperField = {
  label: 'Address',
  key: 'address',
  requireMapping: true,
  alternateMatches: ['street address', 'full address', 'street name + number'],
}
export const citySchema: IDeveloperField = {
  label: 'City',
  key: 'city',
  validators: [{ validate: 'require_with', fields: ['state'] }],
}

const stateOptions = validStateValues.map((state) => ({
  label: state.short,
  value: state.short,
  alternateMatches: [state.full],
}))
export const stateSchema: IDeveloperField = {
  label: 'State',
  key: 'state',
  type: 'select',
  selectOptions: stateOptions,
  validators: [{ validate: 'require_with', fields: ['city'] }],
}

export const zipCodeSchema: IDeveloperField = {
  label: 'Zip Code',
  key: 'zipCode',
}

export const latSchema: IDeveloperField = {
  label: 'Latitude',
  key: 'latitude',
  type: ['number', { displayFormat: { trimMantissa: true, mantissa: 5 } }],
  validators: [{ validate: 'require_with', fields: ['longitude'] }],
}

export const longSchema: IDeveloperField = {
  label: 'Longitude',
  key: 'longitude',
  type: ['number', { displayFormat: { trimMantissa: true, mantissa: 5 } }],
  validators: [{ validate: 'require_with', fields: ['latitude'] }],
}

export const notesSchema: IDeveloperField = { label: 'Notes', key: 'notes' }
